import React from "react"
import { Tabs } from 'antd';
import Dashboard from "./charts/Dashboard";



const Tools = () => {

    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Tools</h1>
                        {/* <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p> */}
                    </div>
                </div>
                <section>
                    <div className="slider-section manage-table-data">
                        <div className="slider-tab-div">

                            <div className="tab-bar">
                                <Tabs>
                                    <Tabs.TabPane tab="Summary" key="1">
                                        <div className=" ">

                                            <Dashboard />

                                        </div>

                                    </Tabs.TabPane>

                                    {/* NEXT VERSION */}
                                    {/* <Tabs.TabPane tab="All Tools" key="2">

                                        <div className="">
                                            <div class="bg-gradient-primary bott-input-line system-line">
                                                <input type="text" className="iocn-search  search-bar" placeholder="Search Tool" />
                                            </div>

                                            <div className="add-new-widget">
                                                <div className="widget-grid-sec">
                                                    <div className="create-inner-circle new-wid ">
                                                        <p><span> <img src={images.add} alt="add" /></span>Add new Tool</p>
                                                    </div>

                                                    <div onClick={() => { navigate('/logmood') }} className="encouragement-group remove-border">
                                                        <h1><span><img src={images.loogMood} alt="groupIcons" /> </span> Log Mood</h1>
                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Enable</p>
                                                            </div>
                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div onClick={() => { navigate('/logthought') }} className="encouragement-group remove-border">
                                                        <h1><span><img src={images.logThoughts} alt="groupIcons" /> </span> Log Thoughts</h1>
                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Enable</p>
                                                            </div>

                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div onClick={() => { navigate('/meditation') }} className="encouragement-group remove-border">
                                                        <h1><span><img src={images.icEncouragment} alt="groupIcons" /> </span> Meditation</h1>

                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Enable</p>
                                                            </div>

                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div onClick={() => { navigate('/playlists') }} className="encouragement-group remove-border">
                                                        <h1><span><img src={images.playListsn} alt="groupIcons" /> </span> Playlists</h1>

                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Enable</p>
                                                            </div>

                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="encouragement-group remove-border">
                                                        <h1><span><img src={images.affirmations} alt="groupIcons" /> </span> Affirmations</h1>

                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Disable</p>
                                                            </div>
                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="encouragement-group remove-border">
                                                        <h1><span><img src={images.journalicon} alt="groupIcons" /> </span> Journal</h1>

                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Disable</p>
                                                            </div>

                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="encouragement-group remove-border">
                                                        <h1><span><img src={images.therapyicon} alt="groupIcons" /> </span></h1>

                                                        <div className="enable-switch switch-bacg-ground">
                                                            <div className="switch-btn switch-btn-op">
                                                                <Switch defaultChecked onChange={onChange3} />
                                                                <p>Disable</p>
                                                            </div>

                                                            <div className="setting-option">
                                                                <img src={images.settingOption} alt="settingOption" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>



                                        </div>

                                    </Tabs.TabPane> */}


                                </Tabs>
                            </div>

                        </div>

                    </div>

                </section>
            </div>
        </div>
    )
}
export default Tools

